import React from 'react';
import TabsView from 'UI/components/templates/TabsView';

import { useStyles } from './DetailsTabs.styled';

export const DetailsTabs = ({ initialTab, tabs = [] }) => {
  const classes = useStyles();

  return (
    <TabsView
      enableUrlNavigation={false}
      initialTab={initialTab}
      panelHeight="unset"
      tabs={tabs}
      useIndexes={false}
      tabPanelProps={{
        className: classes.tabPanel
      }}
    />
  );
};
